enum AccountTypes {
    ACCOUNT_LOADING = "ACCOUNT_LOADING",
    ACCOUNT_LOADED = "ACCOUNT_LOADED",
}

export default AccountTypes
